import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableColorItem = ({
  id,
  value,
  color,
  updateColorClicked,
  idOfColorSelectedForPickerEdit,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: "28px",
    height: "28px",
    border: "1px solid var(--indigo400)",
    borderRadius: "50%",
    backgroundColor: color,
    margin: "4px",
    zIndex: isDragging ? "22" : "auto",
    opacity: isDragging ? 0.7 : 1,
    cursor: "pointer",
  };

  return (
    <div
      type="button"
      className={
        id === idOfColorSelectedForPickerEdit ? "color-dot-selected" : ""
      }
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}>
      <div></div>
    </div>
  );
};

export default SortableColorItem;
